import { FindDashboardItemDTO, FindItem, FindItemsDTO } from "@dto/dashboard.dto";
import TableDashboardSelect from "@parts/table/TableDashboardSelect";
import { Tooltip } from "antd";
import { FC, useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import { API_URL } from "src/data/Api";
import { Log } from "src/service/log.service";
import { postApi } from "src/util/apiCalls";
import { IconSize } from "./XmResetFilterIcon";

export interface XmDashboardStarIconProps {
  size?: IconSize;
  disabled?: boolean;
  selectProps: {
    tabName: string;
    subTabName: string;
    tabId: string;
    dashUrl: string;
    id: string;
  };
}

export const XmTableDashboardStarIcon: FC<XmDashboardStarIconProps> = ({ size = "normal", disabled, selectProps }) => {
  const [timestamp, setTimestamp] = useState(0);
  const [dashboardItems, setDashboardItems] = useState<FindItem[]>([]);

  useEffect(() => {
    const searchBody: FindDashboardItemDTO = { tab: selectProps.tabName, subtab: selectProps.subTabName, tabId: selectProps.tabId, url: selectProps.dashUrl, type: 'table' };
    postApi<FindItemsDTO, FindDashboardItemDTO>(API_URL.DASHBOARD_FIND_ITEM, searchBody).then(response => {
      setDashboardItems(response.data.data);
    }, reason => Log.error('Failed to get table dashboards!', reason));
  }, []);

  return <>
    <Tooltip title="Manage in dashboards">
      <a
        onClick={() => setTimestamp(Date.now())}
        className={disabled || !dashboardItems?.length ? "xm-tbl-not-dash" : "xm-tbl-in-dash"}
      >
        <FaStar className={`xm-icon xm-icon-${size}`} />
      </a>
    </Tooltip>
    <TableDashboardSelect common={{ ...selectProps, dashboardItems, setDashboardItems }} timestamp={timestamp} id={selectProps.id} />
  </>;
}

